<div class="login-container">
  <div class="header">
    <img src="assets/images/common/logo.png" [alt]="'LogChain' | translate" />
  </div>
  <div class="main-container">
    <div class="login-card align-center-item">
      <div class="header-cart mb-5">
        <div class="top">
          <div class="left">{{'Welcome to' | translate}} <b>Log</b>Chain!</div>
          <div class="right">{{ getToday() }}</div>
        </div>
        <div class="title text-center mt-3">{{'Two Factor Authentication' | translate}}</div>
        <div *ngIf="user" class="sub-title text-center">
          {{'Please confirm your phone number by enter the code sent via SMS' | translate}}
        </div>
        <ngb-alert
          class="mt-3"
          *ngIf="errorMsg != ''"
          [type]="'danger'"
          [dismissible]="false"
          >{{ errorMsg }}
        </ngb-alert>
      </div>
      <form [formGroup]="confirmForm" (ngSubmit)="submitForm()">
        <div class="form-group">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              formControlName="phone"
              [max]="12"
              [min]="9"
              required
              placeholder="Enter your phone number"
              mask="+000000000*"
              maxlength="16"
            />
          </div>
          <!-- <small *ngIf="confirmFormControls.code.touched && confirmFormControls.code.invalid"
                class="form-text text-danger">{{getPasswordErrorMessage()}}</small> -->
        </div>
        <div class="btn-group">
          <button
            type="button"
            class="btn btn-secondary mr-3"
            (click)="backToLogin()"
          >
            {{'Go back' | translate}}
          </button>
          <button
            [disabled]="confirmForm.invalid"
            class="btn btn-primary btn-block"
            (click)="submitForm()"
          >
            <span *ngIf="!isLoading">{{'SEND' | translate}}</span>
            <div *ngIf="isLoading" class="spinner-border" role="status"></div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
